import { css } from '@emotion/react';
import { BgVariant, BgGradientVariant } from '../mixins/_background-variant.mixin';


export default $ => css`
  ${css(Object.entries($.themeColors).map(([color, value]) => 
    new BgVariant(`.bg-${color}`, value, true).include($)
  ))}

  ${$.enableGradients ? css(Object.entries($.themeColors).map(([color, value]) => 
    new BgGradientVariant(`.bg-gradient-${color}`, value, true).include($)
  )): css``}

  .bg-white {
    background-color: ${$.white} !important;
  }

  .bg-transparent {
    background-color: transparent !important;
  }
`;
